import { render, staticRenderFns } from "./faceSimple.vue?vue&type=template&id=9cb95048&scoped=true"
import script from "./faceSimple.vue?vue&type=script&lang=js"
export * from "./faceSimple.vue?vue&type=script&lang=js"
import style0 from "./faceSimple.vue?vue&type=style&index=0&id=9cb95048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb95048",
  null
  
)

export default component.exports